// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var DeccoUtils$SmartcutsMacros = require("../../../bs-utils/src/DeccoUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");

var _map = {"Unspecified":"DIMENSION_UNSPECIFIED","Rows":"ROWS","Columns":"COLUMNS"};

var _revMap = {"DIMENSION_UNSPECIFIED":"Unspecified","ROWS":"Rows","COLUMNS":"Columns"};

function tToJs(param) {
  return _map[param];
}

function tFromJs(param) {
  return _revMap[param];
}

var Dimension = {
  tToJs: tToJs,
  tFromJs: tFromJs
};

var DimensionRange = {};

var _map$1 = {"Unspecified":"DEVELOPER_METADATA_LOCATION_TYPE_UNSPECIFIED","Row":"ROW","Column":"COLUMN","Sheet":"SHEET","Spreadsheet":" SPREADSHEET"};

var _revMap$1 = {"DEVELOPER_METADATA_LOCATION_TYPE_UNSPECIFIED":"Unspecified","ROW":"Row","COLUMN":"Column","SHEET":"Sheet"," SPREADSHEET":"Spreadsheet"};

function tToJs$1(param) {
  return _map$1[param];
}

function tFromJs$1(param) {
  return _revMap$1[param];
}

var DeveloperMetadataLocationType = {
  tToJs: tToJs$1,
  tFromJs: tFromJs$1
};

var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});

var t_encode = include.t_encode;

var t_decode = include.t_decode;

function spreadsheet(param) {
  return {
          spreadsheet: true
        };
}

function sheet(sheetId) {
  return {
          sheetId: sheetId
        };
}

function dimensionRange(dimensionRange$1) {
  return {
          dimensionRange: dimensionRange$1
        };
}

function DeveloperMetadataLocation_locationTypeGet(prim) {
  return Caml_option.undefined_to_opt(prim.locationType);
}

function DeveloperMetadataLocation_spreadsheetGet(prim) {
  return Caml_option.undefined_to_opt(prim.spreadsheet);
}

function DeveloperMetadataLocation_sheetIdGet(prim) {
  return Caml_option.undefined_to_opt(prim.sheetId);
}

function DeveloperMetadataLocation_dimensionRangeGet(prim) {
  return Caml_option.undefined_to_opt(prim.dimensionRange);
}

var DeveloperMetadataLocation = {
  t_encode: t_encode,
  t_decode: t_decode,
  locationTypeGet: DeveloperMetadataLocation_locationTypeGet,
  spreadsheetGet: DeveloperMetadataLocation_spreadsheetGet,
  sheetIdGet: DeveloperMetadataLocation_sheetIdGet,
  dimensionRangeGet: DeveloperMetadataLocation_dimensionRangeGet,
  spreadsheet: spreadsheet,
  sheet: sheet,
  dimensionRange: dimensionRange
};

var _map$2 = {"Unspecified":"DEVELOPER_METADATA_VISIBILITY_UNSPECIFIED","Document":"DOCUMENT","Project":"PROJECT"};

var _revMap$2 = {"DEVELOPER_METADATA_VISIBILITY_UNSPECIFIED":"Unspecified","DOCUMENT":"Document","PROJECT":"Project"};

function tToJs$2(param) {
  return _map$2[param];
}

function tFromJs$2(param) {
  return _revMap$2[param];
}

var include$1 = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
      typeName: "GoogleApis.Sheets.Schema.DeveloperMetadataVisibility",
      tToJs: tToJs$2,
      tFromJs: tFromJs$2
    });

var t_encode$1 = include$1.t_encode;

var t_decode$1 = include$1.t_decode;

var DeveloperMetadataVisibility = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "metadataId",
                Decco.optionToJson(Decco.intToJson, v.metadataId)
              ],
              [
                "metadataKey",
                Decco.stringToJson(v.metadataKey)
              ],
              [
                "metadataValue",
                Decco.stringToJson(v.metadataValue)
              ],
              [
                "location",
                Curry._1(t_encode, v.location)
              ],
              [
                "visibility",
                Curry._1(t_encode$1, v.visibility)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var metadataId = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "metadataId"), null));
  if (metadataId.TAG === /* Ok */0) {
    var metadataKey = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metadataKey"), null));
    if (metadataKey.TAG === /* Ok */0) {
      var metadataValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metadataValue"), null));
      if (metadataValue.TAG === /* Ok */0) {
        var $$location = Curry._1(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
        if ($$location.TAG === /* Ok */0) {
          var visibility = Curry._1(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
          if (visibility.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      metadataId: metadataId._0,
                      metadataKey: metadataKey._0,
                      metadataValue: metadataValue._0,
                      location: $$location._0,
                      visibility: visibility._0
                    }
                  };
          }
          var e = visibility._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".visibility" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = $$location._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".location" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = metadataValue._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".metadataValue" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = metadataKey._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".metadataKey" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = metadataId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".metadataId" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

var DeveloperMetadata = {
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

var GridRange = {};

var DeveloperMetadataLocationMatchingStrategy = {};

var DeveloperMetadaLookup = {};

var NamedRange = {};

var _map$3 = {"NUMBER_FORMAT_TYPE_UNSPECIFIED":"NUMBER_FORMAT_TYPE_UNSPECIFIED","TEXT":"TEXT","NUMBER":"NUMBER","PERCENT":"PERCENT","CURRENCY":"CURRENCY","DATE":"DATE","TIME":"TIME","DATE_TIME":"DATE_TIME","SCIENTIFIC":"SCIENTIFIC"};

function tToJs$3(param) {
  return param;
}

function tFromJs$3(param) {
  return _map$3[param];
}

var NumberFormatType = {
  tToJs: tToJs$3,
  tFromJs: tFromJs$3
};

function make(type_, pattern) {
  return {
          type: type_,
          pattern: pattern
        };
}

var NumberFormat = {
  make: make
};

var CellFormat = {};

var IterativeCalculationSettings = {};

var SpreadsheetTheme = {};

function make$1(autoRecalc, defaultFormat, iterativeCalculationSettings, locale, spreadsheetTheme, timeZone, title, param) {
  return {
          autoRecalc: autoRecalc,
          defaultFormat: defaultFormat,
          iterativeCalculationSettings: iterativeCalculationSettings,
          locale: locale,
          spreadsheetTheme: spreadsheetTheme,
          timeZone: timeZone,
          title: title
        };
}

var SpreadsheetProperties = {
  make: make$1
};

var BandedRange = {};

var BasicFilter = {};

var EmbeddedChart = {};

var DimensionGroup = {};

var ConditionalFormatRule = {};

var DimensionProperties = {};

var ConditionValue = {};

var _map$4 = {"CONDITION_TYPE_UNSPECIFIED":"CONDITION_TYPE_UNSPECIFIED","NUMBER_GREATER":"NUMBER_GREATER","NUMBER_GREATER_THAN_EQ":"NUMBER_GREATER_THAN_EQ","NUMBER_LESS":"NUMBER_LESS","NUMBER_LESS_THAN_EQ":"NUMBER_LESS_THAN_EQ","NUMBER_EQ":"NUMBER_EQ","NUMBER_NOT_EQ":"NUMBER_NOT_EQ","NUMBER_BETWEEN":"NUMBER_BETWEEN","NUMBER_NOT_BETWEEN":"NUMBER_NOT_BETWEEN","TEXT_CONTAINS":"TEXT_CONTAINS","TEXT_NOT_CONTAINS":"TEXT_NOT_CONTAINS","TEXT_STARTS_WITH":"TEXT_STARTS_WITH","TEXT_ENDS_WITH":"TEXT_ENDS_WITH","TEXT_EQ":"TEXT_EQ","TEXT_IS_EMAIL":"TEXT_IS_EMAIL","TEXT_IS_URL":"TEXT_IS_URL","DATE_EQ":"DATE_EQ","DATE_BEFORE":"DATE_BEFORE","DATE_AFTER":"DATE_AFTER","DATE_ON_OR_BEFORE":"DATE_ON_OR_BEFORE","DATE_ON_OR_AFTER":"DATE_ON_OR_AFTER","DATE_BETWEEN":"DATE_BETWEEN","DATE_NOT_BETWEEN":"DATE_NOT_BETWEEN","DATE_IS_VALID":"DATE_IS_VALID","ONE_OF_RANGE":"ONE_OF_RANGE","ONE_OF_LIST":"ONE_OF_LIST","BLANK":"BLANK","NOT_BLANK":"NOT_BLANK","CUSTOM_FORMULA":"CUSTOM_FORMULA","BOOLEAN":"BOOLEAN","TEXT_NOT_EQ":"TEXT_NOT_EQ","DATE_NOT_EQ":"DATE_NOT_EQ"};

function tToJs$4(param) {
  return param;
}

function tFromJs$4(param) {
  return _map$4[param];
}

var ConditionType = {
  tToJs: tToJs$4,
  tFromJs: tFromJs$4
};

function make$2(type_, values, param) {
  return {
          type: Belt_Option.map(type_, tToJs$4),
          values: values
        };
}

var BooleanCondition = {
  make: make$2
};

var DataValidationRule = {};

var ErrorValue = {};

function stringValue(string) {
  return {
          boolValue: undefined,
          errorValue: undefined,
          formulaValue: undefined,
          numberValue: undefined,
          stringValue: string
        };
}

function formulaValue(formula) {
  return {
          boolValue: undefined,
          errorValue: undefined,
          formulaValue: formula,
          numberValue: undefined,
          stringValue: undefined
        };
}

var ExtendedValue = {
  stringValue: stringValue,
  formulaValue: formulaValue
};

var PivotTable = {};

var TextFormatRun = {};

function make$3(dataValidation, effectiveFormat, effectiveValue, formattedValue, hyperlink, note, pivotTable, textFormatRuns, userEnteredFormat, userEnteredValue, param) {
  return {
          dataValidation: dataValidation,
          effectiveFormat: effectiveFormat,
          effectiveValue: effectiveValue,
          formattedValue: formattedValue,
          hyperlink: hyperlink,
          note: note,
          pivotTable: pivotTable,
          textFormatRuns: textFormatRuns,
          userEnteredFormat: userEnteredFormat,
          userEnteredValue: userEnteredValue
        };
}

var CellData = {
  make: make$3
};

var RowData = {};

function countRowsMinusHeaderRow(maybeOnlyFirstNRows, param) {
  var arg = Belt_Option.map(param.rowData, (function (rowData) {
          var len = rowData.length;
          var nRows = len === 0 ? len : len - 1 | 0;
          if (maybeOnlyFirstNRows !== undefined && maybeOnlyFirstNRows > nRows) {
            return maybeOnlyFirstNRows;
          } else {
            return nRows;
          }
        }));
  var param$1 = 0;
  return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
}

var GridData = {
  countRowsMinusHeaderRow: countRowsMinusHeaderRow
};

var FilterView = {};

var GridProperties = {};

var Color = {};

var ColorStyle = {};

var SheetProperties = {};

var WithoutEnum = {};

function majorDimensionToJs(majorDimension) {
  switch (majorDimension) {
    case /* Rows */0 :
        return "Rows";
    case /* Cols */1 :
        return "Cols";
    case /* DimensionUnspecified */2 :
        return "DimensionUnspecified";
    
  }
}

function fromWithoutEnum(param) {
  var tmp;
  switch (param.majorDimension) {
    case "COLS" :
        tmp = /* Cols */1;
        break;
    case "DIMENSION_UNSPECIFIED" :
        tmp = /* DimensionUnspecified */2;
        break;
    case "ROWS" :
        tmp = /* Rows */0;
        break;
    default:
      tmp = /* DimensionUnspecified */2;
  }
  return {
          range: param.range,
          majorDimension: tmp,
          values: param.values
        };
}

function toWithoutEnum(param) {
  return {
          range: param.range,
          majorDimension: majorDimensionToJs(param.majorDimension),
          values: param.values
        };
}

var fromJson = fromWithoutEnum;

var ValueRange = {
  WithoutEnum: WithoutEnum,
  majorDimensionToJs: majorDimensionToJs,
  fromWithoutEnum: fromWithoutEnum,
  toWithoutEnum: toWithoutEnum,
  fromJson: fromJson
};

var ProtectedRange = {};

var Slicer = {};

function make$4(bandedRanges, basicFilter, charts, columnGroups, conditionalFormats, data, developerMetadata, filterViews, merges, properties, protectedRanges, rowGroups, slicers, param) {
  return {
          bandedRanges: bandedRanges,
          basicFilter: basicFilter,
          charts: charts,
          columnGroups: columnGroups,
          conditionalFormats: conditionalFormats,
          data: data,
          developerMetadata: developerMetadata,
          filterViews: filterViews,
          merges: merges,
          properties: properties,
          protectedRanges: protectedRanges,
          rowGroups: rowGroups,
          slicers: slicers
        };
}

var Sheet = {
  make: make$4
};

function make$5(developerMetadata, namedRanges, properties, sheets, spreadsheetId, spreadsheetUrl, param) {
  return {
          developerMetadata: developerMetadata,
          namedRanges: namedRanges,
          properties: properties,
          sheets: sheets,
          spreadsheetId: spreadsheetId,
          spreadsheetUrl: spreadsheetUrl
        };
}

function getGridDataFor(spreadsheet, sheetIndex, gridDataIndex) {
  return Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.flatMap(spreadsheet.sheets, (function (sheets) {
                        return Belt_Array.get(sheets, sheetIndex);
                      })), (function (param) {
                    return param.data;
                  })), (function (data) {
                return Belt_Array.get(data, gridDataIndex);
              }));
}

var Spreadsheet = {
  make: make$5,
  getGridDataFor: getGridDataFor
};

var UpdateValuesResponse = {};

var _map$5 = {"InputValueOptionUnspecified":"INPUT_VALUE_OPTION_UNSPECIFIED","Raw":"RAW","UserEntered":"USER_ENTERED"};

var _revMap$3 = {"INPUT_VALUE_OPTION_UNSPECIFIED":"InputValueOptionUnspecified","RAW":"Raw","USER_ENTERED":"UserEntered"};

function tToJs$5(param) {
  return _map$5[param];
}

function tFromJs$5(param) {
  return _revMap$3[param];
}

var ValueInputOption = {
  tToJs: tToJs$5,
  tFromJs: tFromJs$5
};

var _map$6 = {"FormattedValue":"FORMATTED_VALUE","UnformattedValue":"UNFORMATTED_VALUE","Formula":"FORMULA"};

var _revMap$4 = {"FORMATTED_VALUE":"FormattedValue","UNFORMATTED_VALUE":"UnformattedValue","FORMULA":"Formula"};

function tToJs$6(param) {
  return _map$6[param];
}

function tFromJs$6(param) {
  return _revMap$4[param];
}

var ValueRenderOption = {
  tToJs: tToJs$6,
  tFromJs: tFromJs$6
};

var _map$7 = {"SerialNumber":"SERIAL_NUMBER","FormattedString":"FORMATTED_STRING"};

var _revMap$5 = {"SERIAL_NUMBER":"SerialNumber","FORMATTED_STRING":"FormattedString"};

function tToJs$7(param) {
  return _map$7[param];
}

function tFromJs$7(param) {
  return _revMap$5[param];
}

var DateTimeRenderOption = {
  tToJs: tToJs$7,
  tFromJs: tFromJs$7
};

function developerMetadataLookup(developerMetadataLookup$1) {
  return {
          developerMetadataLookup: developerMetadataLookup$1
        };
}

function a1Range(a1Range$1) {
  return {
          a1Range: a1Range$1
        };
}

function gridRange(gridRange$1) {
  return {
          gridRange: gridRange$1
        };
}

var DataFilter = {
  developerMetadataLookup: developerMetadataLookup,
  a1Range: a1Range,
  gridRange: gridRange
};

var MatchedDeveloperMetadata = {};

exports.Dimension = Dimension;
exports.DimensionRange = DimensionRange;
exports.DeveloperMetadataLocationType = DeveloperMetadataLocationType;
exports.DeveloperMetadataLocation = DeveloperMetadataLocation;
exports.DeveloperMetadataVisibility = DeveloperMetadataVisibility;
exports.DeveloperMetadata = DeveloperMetadata;
exports.GridRange = GridRange;
exports.DeveloperMetadataLocationMatchingStrategy = DeveloperMetadataLocationMatchingStrategy;
exports.DeveloperMetadaLookup = DeveloperMetadaLookup;
exports.NamedRange = NamedRange;
exports.NumberFormatType = NumberFormatType;
exports.NumberFormat = NumberFormat;
exports.CellFormat = CellFormat;
exports.IterativeCalculationSettings = IterativeCalculationSettings;
exports.SpreadsheetTheme = SpreadsheetTheme;
exports.SpreadsheetProperties = SpreadsheetProperties;
exports.BandedRange = BandedRange;
exports.BasicFilter = BasicFilter;
exports.EmbeddedChart = EmbeddedChart;
exports.DimensionGroup = DimensionGroup;
exports.ConditionalFormatRule = ConditionalFormatRule;
exports.DimensionProperties = DimensionProperties;
exports.ConditionValue = ConditionValue;
exports.ConditionType = ConditionType;
exports.BooleanCondition = BooleanCondition;
exports.DataValidationRule = DataValidationRule;
exports.ErrorValue = ErrorValue;
exports.ExtendedValue = ExtendedValue;
exports.PivotTable = PivotTable;
exports.TextFormatRun = TextFormatRun;
exports.CellData = CellData;
exports.RowData = RowData;
exports.GridData = GridData;
exports.FilterView = FilterView;
exports.GridProperties = GridProperties;
exports.Color = Color;
exports.ColorStyle = ColorStyle;
exports.SheetProperties = SheetProperties;
exports.ValueRange = ValueRange;
exports.ProtectedRange = ProtectedRange;
exports.Slicer = Slicer;
exports.Sheet = Sheet;
exports.Spreadsheet = Spreadsheet;
exports.UpdateValuesResponse = UpdateValuesResponse;
exports.ValueInputOption = ValueInputOption;
exports.ValueRenderOption = ValueRenderOption;
exports.DateTimeRenderOption = DateTimeRenderOption;
exports.DataFilter = DataFilter;
exports.MatchedDeveloperMetadata = MatchedDeveloperMetadata;
/* include Not a pure module */
